<template>
    <dl class="form-row" :class="{'element-first': elementFirst, 'no-label': !label && !slots.label}">
        <dt class="form-label" v-if="label || slots.label">
            <label :for="labelFor" :class="{'intranet-headline-color': coloredLabel}" :aria-label="label ? label : ''">
                <slot name="label">{{label}}</slot>
                <span class="screen-reader-only">{{helpText}}</span>
            </label>
            <i class="material-icons form-label-help" v-tooltip="{text: helpText, css: helpTooltipCss}" v-if="help" aria-hidden="true" role="img">info</i>
        </dt>

        <dd class="form-element">
            <slot/>
        </dd>
    </dl>
</template>

<script setup lang="ts">
    import {usePortuna} from '@/composables/portuna';
    import {computed} from 'vue';
    import {useSlots} from 'vue-demi';

    const portuna = usePortuna();

    const props = withDefaults(
        defineProps<{
            label?: string;
            labelFor?: string;
            help?: string;
            required?: boolean;
            requiredManually?: boolean;
            elementFirst?: boolean;
            coloredLabel?: boolean;
            helpTooltipCss?: {
                [key: string]: string;
            };
        }>(),
        {
            helpTooltipCss: () => ({}),
            requiredManually: false,
            coloredLabel: false,
        },
    );

    const slots = useSlots();

    const defaultHelpText: {
        [key: string]: string;
    } = {
        multipleFileUpload: 'Sie können bei diesem Datei-Upload beliebig viele Dateien in einem Schritt hochladen. Wählen Sie dazu einfach mehrere Dateien mit Strg + Mausklick in Ihrem Explorer aus.',
    };

    const helpText = computed((): string =>
    {
        let help = props.help!;
        if (typeof defaultHelpText[help] !== 'undefined')
        {
            help = defaultHelpText[help];
        }

        return help;
    });

    defineExpose(Object.assign({}, portuna, {
        componentName: 'FormRowStatic',
    }));
</script>